export const RESET_PAGE_SPECIFIC_FILTERS = 'RESET_PAGE_SPECIFIC_FILTERS';

export function resetPageSpecificFilters(pageId) {
  return {
    type: RESET_PAGE_SPECIFIC_FILTERS,
    pageId,
  };
}
